const swiper = new Swiper('.swiper-carousel', {
  slidesPerView: 1.25,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-carousel .next',
    prevEl: '.swiper-carousel .prev',
  },
  breakpoints: {
    767.98: {slidesPerView: 2.25}
  }
});
